import {
  DashboardOutlined,
  PlusCircleOutlined,
  PictureOutlined,
  NotificationOutlined,
  SettingOutlined,
  ProfileOutlined,
  FormOutlined,
  UserOutlined,
  YoutubeOutlined,
  AccountBookOutlined,
  SnippetsOutlined,
  CommentOutlined,
  ReadOutlined
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "home",
    path: `${APP_PREFIX_PATH}/home`,
    title: "home",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const newNavTree = [
  {
    key: "new",
    title: "Menu",
    icon: "",
    breadcrumb: false,
    submenu: [
      {
        key: "content",
        path: `${APP_PREFIX_PATH}/content`,
        title: "sidenav.content",
        icon: FormOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "content-list",
            path: `${APP_PREFIX_PATH}/content/list`,
            title: "sidenav.content.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "content-add",
            path: `${APP_PREFIX_PATH}/content/add`,
            title: "sidenav.content.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "content-draft",
            path: `${APP_PREFIX_PATH}/content/draft`,
            title: "sidenav.content.draft",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "category",
        path: `${APP_PREFIX_PATH}/category`,
        title: "sidenav.category",
        icon: ProfileOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "category-list",
            path: `${APP_PREFIX_PATH}/category/list`,
            title: "sidenav.category.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "category-add",
            path: `${APP_PREFIX_PATH}/category/add`,
            title: "sidenav.category.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "videogallery",
        path: `${APP_PREFIX_PATH}/videogallery`,
        title: "sidenav.videogallery",
        icon: YoutubeOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "videogallery-list",
            path: `${APP_PREFIX_PATH}/videogallery/list`,
            title: "sidenav.videogallery.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "videogallery-add",
            path: `${APP_PREFIX_PATH}/videogallery/add`,
            title: "sidenav.videogallery.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },

      {
        key: "advertising",
        path: `${APP_PREFIX_PATH}/advertising`,
        title: "sidenav.advertising",
        icon: AccountBookOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "advertising-list",
            path: `${APP_PREFIX_PATH}/advertising/list`,
            title: "sidenav.advertising.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "advertising-add",
            path: `${APP_PREFIX_PATH}/advertising/add`,
            title: "sidenav.advertising.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },

      {
        key: "page",
        path: `${APP_PREFIX_PATH}/page`,
        title: "sidenav.page",
        icon: SnippetsOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "page-list",
            path: `${APP_PREFIX_PATH}/page/list`,
            title: "sidenav.page.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "page-add",
            path: `${APP_PREFIX_PATH}/page/add`,
            title: "sidenav.page.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },

      {
        key: "comments",
        path: `${APP_PREFIX_PATH}/comments`,
        title: "sidenav.comments",
        icon: CommentOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "comment-list",
            path: `${APP_PREFIX_PATH}/comments/list`,
            title: "sidenav.comments.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "banned-words-list",
            path: `${APP_PREFIX_PATH}/banned-words/list`,
            title: "sidenav.banned-words.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "banned-words-add",
            path: `${APP_PREFIX_PATH}/banned-words/add`,
            title: "sidenav.banned-words.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          }

        ],
      },



      {
        key: "notifications",
        path: `${APP_PREFIX_PATH}/notifications`,
        title: "sidenav.notifications",
        icon: NotificationOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "notification-list",
            path: `${APP_PREFIX_PATH}/notifications/notifications-list`,
            title: "sidenav.notification.list",
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "notification-add",
            path: `${APP_PREFIX_PATH}/notifications/add-notification`,
            title: "sidenav.notification.create",
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
        ],
      },

      {
        key: "user",
        path: `${APP_PREFIX_PATH}/user`,
        title: "sidenav.user",
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "user-list",
            path: `${APP_PREFIX_PATH}/user/list`,
            title: "sidenav.user.list",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "user-add",
            path: `${APP_PREFIX_PATH}/user/add`,
            title: "sidenav.user.add",
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },

      {
        key: "setting",
        path: `${APP_PREFIX_PATH}/setting/update`,
        title: "sidenav.setting",
        icon: SettingOutlined,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "report",
        path: `${APP_PREFIX_PATH}/report`,
        title: "sidenav.report",
        icon: ReadOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree, ...newNavTree];

export default navigationConfig;
